import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Planning\GetAssignedPersonController::__invoke
* @see app/Http/Controllers/Planning/GetAssignedPersonController.php
* @route '/api/planning/{event}/person'
*/
const GetAssignedPersonController = (args: { event: string | number | { id: string | number } } | [event: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetAssignedPersonController.url(args, options),
    method: 'get',
})

GetAssignedPersonController.definition = {
    methods: ["get","head"],
    url: '/api/planning/{event}/person',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Planning\GetAssignedPersonController::__invoke
* @see app/Http/Controllers/Planning/GetAssignedPersonController.php
* @route '/api/planning/{event}/person'
*/
GetAssignedPersonController.url = (args: { event: string | number | { id: string | number } } | [event: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { event: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { event: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            event: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        event: typeof args.event === 'object'
        ? args.event.id
        : args.event,
    }

    return GetAssignedPersonController.definition.url
            .replace('{event}', parsedArgs.event.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Planning\GetAssignedPersonController::__invoke
* @see app/Http/Controllers/Planning/GetAssignedPersonController.php
* @route '/api/planning/{event}/person'
*/
GetAssignedPersonController.get = (args: { event: string | number | { id: string | number } } | [event: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetAssignedPersonController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Planning\GetAssignedPersonController::__invoke
* @see app/Http/Controllers/Planning/GetAssignedPersonController.php
* @route '/api/planning/{event}/person'
*/
GetAssignedPersonController.head = (args: { event: string | number | { id: string | number } } | [event: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetAssignedPersonController.url(args, options),
    method: 'head',
})

export default GetAssignedPersonController